var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBlockedIPs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card_1_",
    "data-name": "credit-card (1)",
    transform: "translate(-7.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28754",
    "data-name": "Group 28754",
    transform: "translate(7.7)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47678",
    "data-name": "Path 47678",
    d: "M20.454,4.124a.213.213,0,0,0,.091-.409L12.1.086a1.034,1.034,0,0,0-1.349.5L7.789,7.012a.976.976,0,0,0,.517,1.306l1.7.714a.324.324,0,0,0,.456-.285V6.02a1.925,1.925,0,0,1,1.954-1.893h8.033v0Z",
    transform: "translate(-7.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47679",
    "data-name": "Path 47679",
    d: "M127.918,153.136H117.671a1.019,1.019,0,0,0-1.035,1v7.011a1.019,1.019,0,0,0,1.035,1h1.376a3.527,3.527,0,0,1-.051-.6,3.676,3.676,0,0,1,.064-.671h-1.109v-3.356h9.69v3.353h-1.112a3.675,3.675,0,0,1,.064.671,3.527,3.527,0,0,1-.051.6h1.376a1.019,1.019,0,0,0,1.035-1v-7.007A1.019,1.019,0,0,0,127.918,153.136Zm-.277,2.322h-9.69v-1.051h9.69Z",
    transform: "translate(-112.953 -148.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47680",
    "data-name": "Path 47680",
    d: "M222.893,331.436a2.575,2.575,0,1,0,2.657,2.574A2.617,2.617,0,0,0,222.893,331.436Zm.764,3.589a.844.844,0,0,1-.443.275.121.121,0,0,0-.108.138c0,.075,0,.151,0,.229a.094.094,0,0,1-.1.1q-.127,0-.254,0a.1.1,0,0,1-.108-.111v-.167c0-.121-.007-.128-.128-.147a1.634,1.634,0,0,1-.45-.124c-.112-.052-.125-.079-.091-.193.024-.085.047-.17.074-.252.03-.1.057-.108.152-.062a1.486,1.486,0,0,0,.5.144.626.626,0,0,0,.328-.043.242.242,0,0,0,.061-.432.691.691,0,0,0-.186-.1,3.922,3.922,0,0,1-.511-.223.693.693,0,0,1-.409-.671.742.742,0,0,1,.558-.684c.135-.049.139-.046.139-.183v-.141c0-.1.02-.121.128-.124h.1c.23,0,.23,0,.23.223,0,.157,0,.157.162.18a1.509,1.509,0,0,1,.355.1.1.1,0,0,1,.068.134c-.027.095-.054.193-.088.285s-.061.1-.149.062a1.147,1.147,0,0,0-.561-.108.462.462,0,0,0-.149.03.2.2,0,0,0-.054.367,1.088,1.088,0,0,0,.243.134,3.824,3.824,0,0,1,.446.2A.757.757,0,0,1,223.658,335.025Z",
    transform: "translate(-213.05 -320.583)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBlockedIPs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_blocked_IPs.531cf991a28c28e6be46f5c0f3a10c08.svg";